var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.textstyle {\n    font-family: Arial, Helvetica, sans-serif\n  }\nh1.textstyle {\n    font-family: Arial, Helvetica, sans-serif\n  }\n\n.image1 {\n  background-image: url(" + escape(require("./proto.jpg")) + ");\n  background-color: #ffffff;\n  background-size: cover;\n  /*opacity: 0.5;*/\n}\n\n.blur-box {\n  background-color: rgba(255, 255, 255, 0);\n  box-shadow: 0 0 15px 30px rgb(255, 255, 255);\n}", ""]);

// exports
